import styled from 'styled-components';

import { Link } from 'react-router-dom';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { PageTitle } from 'components/PageTitle';
import { TotadminPermission } from 'data/__generated__';

export const TotopsUserCreated = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.userCreatedTotops} />
                </HeaderTitle>
            </Header>
            <Content>
                <MessageContainer>
                    <Title>Utilisateur Totops créé avec succès</Title>
                    <Message>Un email a été envoyé pour définir le mot de passe.</Message>
                    <Message>
                        Une fois le mot de passe défini, l'utilisateur pourra se connecter via l'application Totops.
                    </Message>
                    <Link to={PAGES.users.url}>
                        <TotemPrimaryButton requiredPermissions={[TotadminPermission.UsersRead]}>
                            Retour aux utilisateurs
                        </TotemPrimaryButton>
                    </Link>
                </MessageContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
`;

const Title = styled.h2`
    color: ${({ theme }) => theme.textColor};
    margin: 0;
`;

const Message = styled.p`
    color: ${({ theme }) => theme.infoTextColor};
    margin: 0;
    text-align: center;
`;
